/* eslint-disable no-unused-vars */
import React from 'react';
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Cell,
  LabelList,
  Text,
} from 'recharts';

interface ChartComposedProps {
  isMulti?: boolean;
  data: any[];
  source?: any;
  brandcount?: number;
}

const CustomizedAxisTick = (props: any) => {
  const { x, y, payload, width, data } = props;
  const barWidth = width / (data?.length || 1);
  const charWidth = 7;
  const maxCharsPerLine = Math.max(3, Math.floor(barWidth / charWidth));

  const splitText = (text: string) => {
    const words = text.split(' ');
    const lines: string[] = [];
    let currentLine = words[0];
    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      if ((currentLine + ' ' + word).length <= maxCharsPerLine) {
        currentLine += ' ' + word;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }
    lines.push(currentLine);
    return lines;
  };

  const lines = splitText(payload.value);

  return (
    <foreignObject
      x={x - barWidth / 2}
      y={y}
      width={barWidth}
      height={lines.length * 15}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%',
          textAlign: 'center',
          fontSize: '12px',
          color: '#4B465C',
          wordBreak: 'break-word',
        }}
      >
        {lines.map((line, i) => (
          <div key={i}>{line}</div>
        ))}
      </div>
    </foreignObject>
  );
};

export default function DataComposedChart(props: ChartComposedProps) {
  const { isMulti = false, data, source, brandcount } = props;

  const maxValue = Math.max(...data.map((item) => item.value || 0));

  return data && data.length > 0 ? (
    <ComposedChart
      width={550}
      height={280 + (data.length > 10 ? 20 : 0)}
      data={data}
      margin={{
        top: 20,
        right: 20,
        bottom: data.length > 10 ? 60 : 20,
        left: 0,
      }}
    >
      <XAxis
        dataKey="name"
        scale="band"
        tick={<CustomizedAxisTick data={data} />}
        interval={0}
        height={data.length > 10 ? 80 : 60}
      />
      <YAxis
        domain={[0, 100]}
        ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
        dataKey="percentage"
        tickFormatter={(value) => `${value}%`}
        axisLine={{ stroke: 'transparent' }}
      />
      <Legend />
      <Tooltip
        content={({ active, payload }) => {
          if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
              <div
                style={{
                  backgroundColor: '#fff',
                  padding: '8px',
                  border: '1px solid #ccc',
                }}
              >
                <p
                  style={{ margin: 0, fontWeight: 'bold' }}
                >{`Sale: ${data.value}`}</p>
              </div>
            );
          }
          return null;
        }}
      />
      <Bar dataKey="percentage" barSize={22}>
        {data.map((entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={entry.value == maxValue ? '#F9AB01' : '#4973A4'}
          />
        ))}
        <LabelList
          dataKey="percentage"
          position="top"
          formatter={(value: number) => `${value.toFixed(2)}%`}
          offset={20}
          fill="#4B465C"
        />
      </Bar>
      <Line
        type="monotone"
        dataKey="percentage"
        stroke="#F9AB01"
        strokeWidth={3}
      />
    </ComposedChart>
  ) : (
    <div className="no-data-graph">No data to display</div>
  );
}
